<template>
  <!--
    应用根组件只负责路由出口：
    - 登录页等全屏页面自行渲染
    - 后台页面挂在 src/views/home.vue（侧边菜单 + 头部导航 + 子页面）
  -->
  <router-view />
</template>
